/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-29 17:17:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/Preview/index.tsx
 */
import React from 'react';
import _ from 'lodash';
import { LongCanvas } from 'unifyxp-ecomm-components';
import { useSelector } from 'react-redux';

import { getLongCanvas } from '../slice';

import styles from './style.module.less';

function Preview() {
  const longCanvas = useSelector(getLongCanvas());

  const dummy = () => void 0;

  const transformData = () => {
    if (Array.isArray(longCanvas)) {
      return longCanvas.map((l) => ({
        imageUrl: _.get(l, 'linkImage.url', ''),
        onClick: dummy,
      }));
    } else {
      return [];
    }
  };

  return (
    <div className={styles.container}>
      <LongCanvas imageProps={transformData()} />
    </div>
  );
}

export default Preview;
